import { memo } from "react";
import { StyleProp, View, ViewStyle } from "react-native";

type TableCellProps = {
  style?: StyleProp<ViewStyle>;
  children?: React.ReactNode;
  accessibilityRole?: "columnheader" | "cell";
  testID?: string;
};

function TableCell({ style, children, accessibilityRole = "cell", testID }: TableCellProps) {
  return (
    // @ts-expect-error TS2769: No overload matches this call.
    <View style={style} accessibilityRole={accessibilityRole} testID={testID}>
      {children}
    </View>
  );
}

export default memo(TableCell);
